import { type FilterItem } from 'widgets/FilterEditor/model'

export const CampaignStatusKeys = new Set(['campaigns.status'])

export const isCampaignStatusWidget = (filterItem: FilterItem) =>
  CampaignStatusKeys.has(filterItem.key)
